import { post } from "../../root/modules/http/post.js";
import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";
import { userInteractions } from "../../root/modules/telemetry/data/user-interactions.js";
import { postMessage } from "./post-message.js";

const acknowledgeLog = log(loggingContexts.acknowledge);

export const acknowledgeAlert = async ({ alertID, caseID, caseNumber }) => {
  postMessage({
    message: {
      alertID,
      caseID,
      request: "silenceAlert",
    },
  });

  postMessage({
    message: {
      args: [
        {
          data: {
            alertID,
            caseID,
            caseNumber,
          },
          type: userInteractions.acknowledgeCase,
        },
      ],
      request: "trackLastUserInteraction",
    },
  });

  postMessage({
    message: {
      args: [
        "Alert window 'Acknowledge' button clicked.",
        { alertID, caseID, caseNumber },
      ],
      context: "USER_INTERACTION",
      level: "info",
      request: "log",
    },
  });

  const productKey = localStorage.getItem("productKey");

  try {
    await post(
      `${import.meta.env.VITE_API_URL}/notification/alerters/acknowledge`,
      { json: { alertID, caseID, productKey } }
    ).json();

    return true;
  } catch (error) {
    acknowledgeLog.error(
      "error acknowledging",
      `${import.meta.env.VITE_API_URL}/notification/alerters/acknowledge`
    );

    let errorDetails;

    if (error.response) {
      const response = await error.response.json();

      acknowledgeLog.info(
        "acknowledging failed (HTTP error)",
        response.message
      );

      errorDetails = response.message;
    } else {
      acknowledgeLog.info(
        "acknowledging failed (unknown error)",
        error.message
      );

      errorDetails = error.message;
    }

    window.alert(`Acknowledging failed: ${errorDetails}`);

    return false;
  }
};
